import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrPartnerSection = ({ title, titleWeight, headerRow, children, padding }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <div className="SrPartnerSection" style={{ padding }}>
      <div className="flex" style={{ position: 'relative' }}>
        {title && (
          <SrBox marginRight={isSmallScreen ? '25px' : null}>
            <SrText
              font="greycliff"
              weight={String(titleWeight || '800')}
              fontSize="28px"
              lineHeight="34px"
            >
              {title}
            </SrText>
          </SrBox>
        )}
        {headerRow}
      </div>
      <div className="sectionContent">{children}</div>
    </div>
  );
};

SrPartnerSection.propTypes = {
  title: PropTypes.string,
  titleWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headerRow: PropTypes.node,
  children: PropTypes.node.isRequired,
  padding: PropTypes.string,
};

SrPartnerSection.displayName = 'SrPartnerSection';

export default SrPartnerSection;
